import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CurrencySelectorComponent } from './currency-selector.component';
import { RichDropdownComponent } from '@roomex/rx-components'
import { TranslocoModule } from '@ngneat/transloco';


@NgModule({
  imports: [    
    CommonModule,
    RichDropdownComponent,
    TranslocoModule
  ],
  declarations: [CurrencySelectorComponent],
  exports: [CurrencySelectorComponent]
})
export class CurrencySelectorModule { }
